import { WhySmartyPlans } from './why-smarty'

export default WhySmartyPlans
